import { createTheme } from "@mui/material/styles";

export const createWCAGTheme = (baseTheme) => {
  return createTheme({
    ...baseTheme,
    components: {
      ...baseTheme.components,
      MuiTabs: {
        styleOverrides: {
          root: {
            overflow: 'visible',
            '& .MuiTabs-scroller': {
              overflow: 'visible'
            }
          },
          indicator: {
            backgroundColor: '#337abb'
          }
        }
      },
      MuiTab: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              color: '#337abb'
            },
            '&:focus-visible, &.Mui-focusVisible': {
              '@media (prefers-contrast: more)': {
                outline: '4px solid #000000',
                outlineOffset: '4px'
              },
              '@media (forced-colors: active)': {
                outline: '3px solid ButtonText',
                outlineOffset: '4px'
              }
            }
          }
        }
      },
      MuiSwitch: {
        styleOverrides: {
          root: {
            overflow: 'visible',
            '@media (forced-colors: active)': {
              forcedColorAdjust: 'none',
              '& .MuiSwitch-track': {
                backgroundColor: 'Canvas',
                border: '2px solid ButtonBorder'
              },
              '& .MuiSwitch-thumb': {
                backgroundColor: 'ButtonText'
              },
              '&.Mui-checked .MuiSwitch-track': {
                backgroundColor: 'Highlight'
              },
              '&.Mui-checked .MuiSwitch-thumb': {
                backgroundColor: 'HighlightText'
              }
            }
          },
          track: {
            backgroundColor: '#808080',
            opacity: 1
          },
          switchBase: {
            '& .MuiSwitch-thumb': {
              boxShadow: '0 2px 4px 0 rgba(0,0,0,0.3), 0 0 0 1px rgba(0,0,0,0.1)'
            },
            '&:focus-visible, &.Mui-focusVisible, &:focus, &.Mui-checked:focus-visible, &.Mui-checked.Mui-focusVisible': {
              '@media (prefers-contrast: more)': {
                outline: '4px solid #000000',
                outlineOffset: '4px'
              },
              '@media (forced-colors: active)': {
                outline: '3px solid ButtonText',
                outlineOffset: '4px'
              }
            }
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            '@media (forced-colors: active)': {
              border: '1px solid ButtonBorder',
              backgroundColor: 'Canvas',
              color: 'CanvasText'
            },
            '&:focus-visible, &:focus-within': {
              '@media (prefers-contrast: more)': {
                outline: '4px solid #000000',
                outlineOffset: '2px'
              },
              '@media (forced-colors: active)': {
                outline: '3px solid ButtonText'
              }
            }
          },
          input: {
            '&::placeholder': {
              color: '#767676',
              opacity: 1
            }
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            '&:focus-visible, &.Mui-focusVisible': {
              '@media (prefers-contrast: more)': {
                outline: '4px solid #000000',
                outlineOffset: '2px'
              },
              '@media (forced-colors: active)': {
                outline: '3px solid ButtonText',
                backgroundColor: 'Highlight',
                color: 'HighlightText'
              }
            }
          }
        }
      }
    }
  });
};
